import { USER_SELECTED_LANG_COOKIE } from '@constants'
import { getCountryCodeFromPathname } from '@utils'
import Cookies from 'js-cookie'

export function useCosignCookies() {
  const account = Cookies.get('account')
  const countryCode = Cookies.get('country_code')
  const country = getCountryCodeFromPathname(window.location.pathname, 'TW')
  const local = Cookies.get(USER_SELECTED_LANG_COOKIE) || 'zh_TW'

  return {
    account,
    countryCode,
    country,
    local,
  }
}
